import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=54eea656&scoped=true&"
import script from "./UpdateAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateAddress.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAddress.vue?vue&type=style&index=0&id=54eea656&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eea656",
  null
  
)

export default component.exports